import { SVGProps } from 'react'

type ConnectIconProps = SVGProps<SVGSVGElement>

const ConnectIcon = ({ className, ...props }: ConnectIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="5"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    className={className}
    {...props}
  >
    <circle cx="12" cy="12" r="9" />
  </svg>
)
export default ConnectIcon
